var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"more-options far fa-ellipsis-h",class:_vm.active ? 'active' : ''})])}
var staticRenderFns = []

export { render, staticRenderFns }